import React, { FC } from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { TokenSelector } from '@app/components/Swap/components/TokenSelector';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import {
  getCurrencyFromKimToken,
  getKimTokenFromCurrency
} from '@app/helpers/currency';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';

export const TokensSelector: FC = () => {
  const {
    currencyA,
    currencyB,
    actions: { setCurrencyA, setCurrencyB }
  } = useLiquidityWizardState();

  const chainid = useSupportedChain()?.chainId;

  return (
    <Box w="100%">
      <AddLiquiditySectionTitle
        label="Select a pair"
        isCompleted={!!(currencyA && currencyB)}
      />
      <HStack
        p={['24px 0', '24px 12px']}
        gap="12px"
        justifyContent="space-between"
      >
        <VStack alignItems="flex-start">
          <Text>Token 1</Text>
          <TokenSelector
            onSelect={token => {
              if (!chainid) {
                return;
              }

              const currency = getCurrencyFromKimToken(token, chainid);

              if (!currency) {
                return;
              }

              if (
                currency.wrapped.address.toLowerCase() ===
                currencyB?.wrapped.address.toLowerCase()
              ) {
                return;
              }

              setCurrencyA(currency);
            }}
            disabled={false}
            selected={getKimTokenFromCurrency(currencyA)}
          />
        </VStack>
        <VStack alignItems="flex-start">
          <Text>Token 2</Text>
          <TokenSelector
            onSelect={token => {
              if (!chainid) {
                return;
              }

              const currency = getCurrencyFromKimToken(token, chainid);

              if (!currency) {
                return;
              }

              if (
                currency.wrapped.address.toLowerCase() ===
                currencyA?.wrapped.address.toLowerCase()
              ) {
                return;
              }

              setCurrencyB(currency);
            }}
            disabled={false}
            selected={getKimTokenFromCurrency(currencyB)}
          />
        </VStack>
      </HStack>
    </Box>
  );
};
